import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAuthData } from '../../utils/auth';
import logo from '../../assets/logo.svg';
import './DashboardHeader.css';
import { ROUTES } from '../../constants/app';

function DashboardHeader({ onStatsClick }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuthData();
    navigate(ROUTES.HOME);
  };

  return (
    <div className="dashboard-header">
      <div className="header-left">
        <img src={logo} alt="India Exchange 25 Chennai" className="dashboard-logo" />
      </div>
      <div className="header-buttons">
        <button className="stats-link" onClick={onStatsClick}>
          Collection Statistics
        </button>
        <button className="back-link" onClick={() => navigate(ROUTES.HOME)}>
          Home
        </button>
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}

export default DashboardHeader;
